import { render, staticRenderFns } from "./similar.vue?vue&type=template&id=3a95140e&"
import script from "./similar.vue?vue&type=script&lang=js&"
export * from "./similar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports